<script setup>
import {computed, onMounted, ref} from "vue";

const props = defineProps({
    message: {
        type: String,
        default: ''
    },
    text: {
        type: String,
        default: ''
    },
    isSuccess: {
        type: Boolean,
        default: true,
    }
});

const isMounted = ref(false);
const toast = ref(null);

const title = computed(()=>{
    return props.message?.title ?? props.message;
})

const text = computed(()=>{
    return props.message?.text ?? null;
})

const isError = computed(()=>{
    return props.message?.isError ?? false;
})

const closeToast = ()=>{
    isMounted.value = false;
}

onMounted(()=>{
    setTimeout(()=>{
        isMounted.value = true;
    }, 5);

    setTimeout(()=>{
        closeToast();
    }, 5000);

})
</script>

<template>
    <dialog ref="toast" class="toastMessage" :class="{'-is-mounted': isMounted}">
        <span class="toastMessage-title h5" v-html="title"></span>
<!--        <div v-if="text" class="toastMessage-text" v-html="text"></div>-->
        <button class="toastMessage-close" @click="closeToast()">⨯</button>
    </dialog>
</template>

<style lang="scss" scoped>
@use '~@/base/variables' as *;

.toastMessage {
    max-width: 385px !important;
    position: fixed;
    z-index: 10;
    bottom: 70px;
    left: initial;
    right: 20px;
    border-radius: 8px;
    border: 1px solid $green500;
    background-color: $green500;
    padding: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    transform: translateY(calc(200% + 70px));
    transition: transform ease-in-out 400ms 200ms;
    filter: drop-shadow(0 4px 8px #C0D2E440);
    color: white;

    &.-is-mounted{
        transform: translateY(0);
    }
    &-close {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 15px;
        height: 15px;
        line-height: 1;
        font-size: 23px;
        cursor: pointer;
        color: white;
        background: none;
        border: none;
        padding: 0;
    }
    &-title{
        text-align: left;
    }
}
</style>
